import React from "react";
import ReactDOM from "react-dom/client";

// Fuentes auto-hospedadas (@fontsource): se sirven desde nuestro propio
// dominio, no desde Google Fonts. Es una plataforma de menores de una
// agencia de gobierno; no hace falta exponer la IP de cada kiosco a un
// tercero para pintar texto. Solo el subconjunto "latin" y los pesos en uso.
import "@fontsource/nunito/latin-400.css";
import "@fontsource/nunito/latin-600.css";
import "@fontsource/nunito/latin-700.css";
import "@fontsource/nunito/latin-800.css";
import "@fontsource/baloo-2/latin-700.css";
import "@fontsource/baloo-2/latin-800.css";
// "Letra fácil de leer" del panel de Accesibilidad. Importar el CSS solo
// declara el @font-face: el navegador no descarga el archivo hasta que alguien
// activa la opción, así que no le cuesta nada a quien no la usa.
import "@fontsource/atkinson-hyperlegible/latin-400.css";
import "@fontsource/atkinson-hyperlegible/latin-700.css";

import { App } from "./App";
import { PanelAccesibilidad } from "./components/PanelAccesibilidad";
import { iniciarAccesibilidad } from "./lib/accesibilidad";
import "./index.css";
// Después de index.css: sus reglas cuelgan de clases en <html> y no dependen
// del orden, pero así quien lea la cascada las encuentra al final.
import "./estilos/accesibilidad.css";

// ANTES del render: si alguien dejó la letra al 150 % o el alto contraste, la
// primera pintura ya sale así. Aplicarlo en un efecto daría un parpadeo con la
// letra pequeña, que es justo lo que no puede leer quien lo activó.
iniciarAccesibilidad();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    {/* Fuera de las rutas: en TODAS las pantallas, la de entrada incluida.
        Ver el porqué en PanelAccesibilidad.tsx. */}
    <PanelAccesibilidad />
  </React.StrictMode>
);
